import { render, staticRenderFns } from "./VeJwCjZfModal__Style#Drawer.vue?vue&type=template&id=52edbfc6&scoped=true"
import script from "./VeJwCjZfModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./VeJwCjZfModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./VeJwCjZfModal__Style#Drawer.vue?vue&type=style&index=0&id=52edbfc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52edbfc6",
  null
  
)

export default component.exports